'use strict';

module.exports = {
    SIGN: 'Aanmelden',
    SIGN_JOIN: 'Gratis Inschrijven of Aanmelden!',
    EMAIL_EXISTS: 'Deze gebruikersnaam bestaat al.',
    INVALID_EMAIL: 'Voer alsjeblieft een geldig emailadres in.',
    INVALID_FIRST_NAME: 'Voer een geldige voornaam in',
    INVALID_LAST_NAME: 'Voer een geldige achternaam in',
    INVALID_PASSWORD: 'Voer tussen de 6 - 20 tekens (alleen A-Z, a-z, 0-9) in',
    INVALID_REPASSWORD: 'Wachtwoorden stemmen niet overeen',
    INVALID_VALID_CODE: 'Voer een geldige code in',
    UNAVIALABLE_SERVICE: 'Service is niet beschikbaar. Probeer het lager nogmaals.',
    EMPTY_VALID_CODE: 'Type de tekens in die u in het beeld ziet',
    NOT_MEMBER: 'Geen Lid?',
    ALREADY_MEMBER: 'Bent u al lid van AliExpress/Alibaba?',
    EMAIL: 'E-mailadres',
    CONTACT_NAME: 'Contactnaam',
    FIRST_NAME: 'Voornaam',
    LAST_NAME: 'Achternaam',
    PASSWORD: 'Wachtwoord',
    REPASSWORD: 'Voer uw wachtwoord opnieuw in:',
    EMPTY_CODE: 'Voer de getoonde code in:',
    REFRESH: 'Verversen',
    AE_MEMBER_SHIP: 'AliExpress.com Gratis Lidmaatschap Overeenkomst',
    CREATE_MY_ACCOUNT: 'Maak mijn account',
    NAME: 'Naam',
    VERIFICATION: 'Verificatie code',
    AGREE_MENT: 'Door een account aan te maken, gaat u akkoord met de voorwaarden van de',
    AND: 'en',
    PRIVACY_POLICY: 'het privacybeleid van AliExpress',
    SLIDE_SUBMIT: 'Schuif naar rechts om te verifiëren',
    SLIDE_SUBMIT_TIPS: 'Succes',
    LOADING: 'Laden…..',
    SLIDE_SUBMIT_ERROR_TIPS: 'Schuif naar rechts om te verifiëren',
    SHOP_NOW: 'WINKEL NU',
    SIGN_IN: 'Inloggen',
    REGISTER_SMS: 'Inschrijven via SMS',
    REGISTER_EMAIL: 'Inschrijven via e-mail',
    PHONE_NUMBER: 'Telefoonnummer',
    VALID_NUMBER: 'Voer een geldig telefoonnummer in.',
    SEND_SMS_CODE: 'SMS-code verzenden',
    SMS_POLICY: 'We sturen een verificatiecode via SMS naar het telefoonnummer dat jij hebt ingevoerd. Controleer of de landcode en het telefoonnummer juist zijn.',
    SEND_TO: 'We hebben de code verzonden naar',
    VERIFICATION_RECEIVED: 'Voer de code die je ontvangen hebt in of',
    EDIT_NUMBER: 'bewerk het nummer.',
    RESEND_CODE: 'Code opnieuw verzenden',
    LAST_STEP: 'Laatste stap',
    SET_SIGN_IN_PASSWORD: 'Stel een aanmeldingswachtwoord in om jouw account veiliger te maken.',
    INVALID_PHONE_PASSWORD: '6-20 karakter (enkel letters en cijfers)',
    NOT_CORRECT_CODE: 'De code is onjuist, probeer het opnieuw.',
    SAVE_PASSWORD: 'Wachtwoord opslaan',
    NO_RECEIVED_CODE: 'Als je de code nog niet ontvangen hebt, probeer',
    VIA_EMAIL: 'je aan te melden via e-mail'
};